var _excluded = ["children", "pre"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
var StyledCode = styled.code.withConfig({
  componentId: "CL__sc-u9vgb9-0"
})(["font-family:var(--mono-typeface);font-size:inherit;color:var(--highlight-color);word-break:break-word;"]);
var StyledPre = styled.pre.withConfig({
  componentId: "CL__sc-u9vgb9-1"
})(["display:block;& ", "{word-break:normal;}"], StyledCode);
var Code = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      children,
      pre = false
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, pre ? /*#__PURE__*/React.createElement(StyledPre, props, /*#__PURE__*/React.createElement(StyledCode, {
    ref: ref
  }, children)) : /*#__PURE__*/React.createElement(StyledCode, _extends({
    ref: ref
  }, props), children));
});
export default Code;